export const VENDOR_PROFILE_ACTION = "VENDOR_PROFILE_ACTION";
export const VENDOR_PROFILE_LOADING = "VENDOR_PROFILE_LOADING";
export const VENDOR_PROFILE_SUCCESS = "VENDOR_PROFILE_SUCCESS";
export const VENDOR_PROFILE_ERROR = "VENDOR_PROFILE_ERROR";

export const VENDOR_TRANSACTIONS_ACTION = "VENDOR_TRANSACTIONS_ACTION";
export const VENDOR_TRANSACTIONS_LOADING = "VENDOR_TRANSACTIONS_LOADING";
export const VENDOR_TRANSACTIONS_SUCCESS = "VENDOR_TRANSACTIONS_SUCCESS";
export const VENDOR_TRANSACTIONS_ERROR = "VENDOR_TRANSACTIONS_ERROR";

export const VENDOR_OVERVIEW_ACTION = "VENDOR_OVERVIEW_ACTION";
export const VENDOR_OVERVIEW_LOADING = "VENDOR_OVERVIEW_LOADING";
export const VENDOR_OVERVIEW_SUCCESS = "VENDOR_OVERVIEW_SUCCESS";
export const VENDOR_OVERVIEW_ERROR = "VENDOR_OVERVIEW_ERROR";

export const VENDOR_SETTLEMENTS_ACTION = "VENDOR_SETTLEMENTS_ACTION";
export const VENDOR_SETTLEMENTS_LOADING = "VENDOR_SETTLEMENTS_LOADING";
export const VENDOR_SETTLEMENTS_SUCCESS = "VENDOR_SETTLEMENTS_SUCCESS";
export const VENDOR_SETTLEMENTS_ERROR = "VENDOR_SETTLEMENTS_ERROR";

export const VENDOR_QR_CODE_ACTION = "VENDOR_QR_CODE_ACTION";
export const VENDOR_QR_CODE_LOADING = "VENDOR_QR_CODE_LOADING";
export const VENDOR_QR_CODE_SUCCESS = "VENDOR_QR_CODE_SUCCESS";
export const VENDOR_QR_CODE_ERROR = "VENDOR_QR_CODE_ERROR";

export const UPDATE_DISCOUNT_PERCENTAGE_ACTION = "UPDATE_DISCOUNT_PERCENTAGE_ACTION";
export const UPDATE_DISCOUNT_PERCENTAGE_LOADING = "UPDATE_DISCOUNT_PERCENTAGE_LOADING";
export const UPDATE_DISCOUNT_PERCENTAGE_SUCCESS = "UPDATE_DISCOUNT_PERCENTAGE_SUCCESS";
export const UPDATE_DISCOUNT_PERCENTAGE_ERROR = "UPDATE_DISCOUNT_PERCENTAGE_ERROR";

export const DOWNLOAD_QR_CODE_ACTION = "DOWNLOAD_QR_CODE_ACTION";
export const DOWNLOAD_QR_CODE_LOADING = "DOWNLOAD_QR_CODE_LOADING";
export const DOWNLOAD_QR_CODE_SUCCESS = "DOWNLOAD_QR_CODE_SUCCESS";
export const DOWNLOAD_QR_CODE_ERROR = "DOWNLOAD_QR_CODE_ERROR";

export const UPDATE_VENDOR_PROFILE_ACTION = "UPDATE_VENDOR_PROFILE_ACTION";
export const UPDATE_VENDOR_PROFILE_LOADING = "UPDATE_VENDOR_PROFILE_LOADING";
export const UPDATE_VENDOR_PROFILE_SUCCESS = "UPDATE_VENDOR_PROFILE_SUCCESS";
export const UPDATE_VENDOR_PROFILE_ERROR = "UPDATE_VENDOR_PROFILE_ERROR";
